export const scrollToTopOfScrollable = () => {
  const element = document.getElementById("mainDivBox");

  if (element) {
    element.scrollTop = 0;
  }
};
